module.exports = fox._r("flash/LiveShow_user.swf", __webpack_public_path__ + "_/_/_/root/flash/LiveShow_user.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/flash/LiveShow_user.swf
// module id = 667
// module chunks = 4